/**
 * The publications screen's registration with the data area's composer.
 */

import { createElement, type ReactNode } from 'react';
import { Gauge, List, Newspaper } from 'lucide-react';
import { useParams } from '@tanstack/react-router';

import type { RouteBundle } from '../../routes/contract';
import { useCampaignOrganisationId, useCan } from '../../session/orgContext';
import { pub } from './messages';
import { PUBLICATIONS_PATH, publicationPath } from './paths';
import { Publications } from './Publications';

const DATA_READ = 'control_plane.read';
const DATA_WRITE = 'control_plane.write';

function PublicationsRoute(): ReactNode {
  const { campaignId } = useParams({ strict: false }) as { campaignId?: string };
  const tenantId = useCampaignOrganisationId();
  const canReclassify = useCan(DATA_WRITE);
  if (tenantId === null) return null;
  return createElement(Publications, {
    // Keyed so a campaign switch starts from that campaign's own filters.
    key: campaignId,
    campaignId: campaignId ?? '',
    tenantId,
    hrefFor: (entry) => publicationPath(campaignId ?? '', entry.post.post_id),
    canReclassify,
  });
}

export const bundle: RouteBundle = {
  routes: [
    {
      path: PUBLICATIONS_PATH,
      element: createElement(PublicationsRoute),
      requires: DATA_READ,
      kind: 'data',
    },
  ],
  nav: [],
  campaignNav: [
    {
      path: PUBLICATIONS_PATH,
      label: () => pub('title'),
      requires: DATA_READ,
      icon: Newspaper,
      order: 30,
      kind: 'data',
    },
    {
      path: PUBLICATIONS_PATH,
      label: () => pub('nav.overview'),
      requires: DATA_READ,
      parent: PUBLICATIONS_PATH,
      icon: Gauge,
      search: { view: 'feed' },
      order: 31,
      kind: 'data',
    },
    {
      path: PUBLICATIONS_PATH,
      label: () => pub('nav.list'),
      requires: DATA_READ,
      parent: PUBLICATIONS_PATH,
      icon: List,
      search: { view: 'list' },
      order: 32,
      kind: 'data',
    },
  ],
};
